<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vx-card>
    <div class="p-3 login-tabs-container">
      <div class="vx-card__title mb-base text-center">
        <h3 class="mb-3 font-weight-bolder">&#128075; {{ $t("login.welcome") }}!</h3>
        <p class="text-muted">{{ $t("login.sendOutPackage") }}!</p>
      </div>

      <form>
        <ValidationObserver ref="formLogin">
          <div class="mb-base">
            <div class="w-full mb-3">
              <ValidationProvider name="emailOrPhone" rules="required" v-slot="{ valid, errors }">
                <vs-input
                  name="Email"
                  :label="$t('attribute.email')"
                  v-model="form.email_or_phone"
                  :danger="valid == false"
                  :danger-text="errors[0]"
                  @keyup.enter="login()"
                  class="w-full"
                />
              </ValidationProvider>
            </div>
            <div class="w-full mb-3">
              <ValidationProvider name="password" rules="required" v-slot="{ errors }">
                <vs-input
                  name="Password"
                  type="password"
                  :label="$t('attribute.password')"
                  v-model="form.password"
                  @keyup.enter="login()"
                  class="w-full"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="mb-2" v-for="error in api_errors" :key="error.message">
              <vs-alert color="danger" icon="new_releases">
                <span>{{ error }}</span>
              </vs-alert>
            </div>
          </div>
          <vs-button style="width: 100%" @click.prevent="login()">{{ $t("login.signIn") }}</vs-button>
        </ValidationObserver>
      </form>

      <vs-divider>{{ $t("login.or") }}</vs-divider>
      <div class="mb-2">
        <small class="text-center">
          {{ $t("login.forgotPassword") }}?
          <router-link to="/account/forget-password">{{ $t("login.changeHere") }}</router-link>
        </small>
      </div>
      <div class="mb-2">
        <small class="text-center">
          {{ $t("login.newToVite") }}? <router-link to="/register">{{ $t("login.signUp") }}</router-link>
        </small>
      </div>
      <div class="mb-2">
        <small class="text-center">
          {{ $t("login.needHelp") }}?
          <router-link to="/helpcenter?origin=public_customer">{{ $t("login.clickHere") }}</router-link>
        </small>
      </div>
      <div vs-offset="8" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4" class="country-selection mb-2">
        <vs-dropdown vs-custom-content vs-trigger-click>
          <a class="toggler cursor-pointer" href.prevent v-if="country_session">
            <img :src="country_session.flag" width="auto" height="10" class="mr-2" />
            {{ country_session.name }} <vs-icon class="" icon="expand_more"></vs-icon>
          </a>

          <vs-dropdown-menu class="loginx">
            <vs-dropdown-item
              v-for="(country, index) in $store.state.country.country_list"
              :key="`country_${index}`"
              @click="onClickCountryDropdownItem(country)"
            >
              <img :src="country.flag" width="auto" height="10" class="mr-2" />
              {{ country.name }}
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </div>
  </vx-card>
</template>

<style>
.country-selection .toggler {
  outline: none;
  text-decoration: none !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.country-selection .vs-select--input {
  font-size: 13px;
}
.country-selection .parent-dropdown {
  cursor: pointer;
}
</style>

<script>
import Crypto from "@/helper/crypto";
import ErrorHandler from "@/helper/error_handler";
import vSelect from "vue-select";
import Global from "@/helper/global";
import axios from "axios";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  data() {
    return {
      form: {
        email_or_phone: "",
        password: "",
      },
      api_errors: [],
      country_session: this.$store.getters.getUserCountry,
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    "v-select": vSelect,
  },
  computed: {
    isEmailLogin() {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.form.email_or_phone.trim());
    },
  },
  created() {
    Global.initializeCountryCurrency(this);
  },
  mounted() {
    this.renderContainerClass();
  },
  methods: {
    renderContainerClass() {
      const name = "vx-row no-gutter justify-center items-center d-theme-dark-bg";

      return name;
    },
    async login() {
      this.api_errors = [];

      try {
        const valid = await this.$refs.formLogin.validate();

        if (!valid) {
          return;
        }

        this.$vs.loading({
          type: "radius",
          text: "Doing Science ...",
        });

        let param = {
          password: this.form.password,
        };

        if (this.isEmailLogin) {
          param.email = this.form.email_or_phone;
        } else {
          param.phone_number = this.form.email_or_phone;
        }

        this.$http
          .post(this.$endpoints.user_login, param)
          .then((res) => {
            const response = res.data.data;
            const encrypted = Crypto.encrypt(response.token);

            this.$store
              .dispatch("setUser", { vm: this, token: encrypted })
              .then((res) => {
                if (!this.$store.getters.getUser.is_customer) {
                  this.$router.replace({ name: "setup-account" }).catch(() => true);
                } else {
                  //Web only has customer
                  this.$store
                    .dispatch("retrieveCustomerInfo")
                    .then(() => {
                      this.$router.replace({ name: "customer-dashboard" }).catch(() => true);
                    })
                    .catch((err) => {
                      this.$store.dispatch("removeUserInfo");
                      this.api_errors = ErrorHandler.processErrorMessage(err);
                    });
                }
              })
              .catch((err) => {
                this.api_errors = ErrorHandler.processErrorMessage(err);
              });
          })
          .catch((err) => {
            console.log(err);
            this.api_errors = ErrorHandler.processErrorMessage(err);
          })
          .finally(() => {
            this.$vs.loading.close();
          });
      } catch (err) {
        console.log(err);
        this.$vs.loading.close();
      }
    },
    onClickCountryDropdownItem(country) {
      this.country_session = country;
      this.updateCountrySetting();
    },
    async updateCountrySetting() {
      let country_id = this.country_session.id;
      let selectedCountry = this.$store.state.country.country_list.find((country) => country.id == country_id);

      if (selectedCountry) {
        this.$store
          .dispatch("changeCountrySelection", selectedCountry)
          .then((res) => {
            this.$vs.loading.close();
            //location.reload();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
};
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }

  .bg-blue {
    background-color: #00aaff;
  }
}
</style>
